<template>
    <div class="auth">
        <mu-row justify-content="center" align-items="center">
            <mu-col span="12" sm="12" md="7" lg="5" xl="5">

                <!-- Alerta de conexão -->
                <mu-alert color="error" v-if="!onLine">
                    <font-awesome-icon icon="ban" class="icon-lg icon-margin-left"/>
                    <div style="padding: 0 0 0 10px">Verifique sua conexão com a internet.</div>
                </mu-alert>

                <div class="login" v-if="screen == 'login' && !loading.status">
                    <mu-title type="h2" color="primary" textStrong="700">Acessar Plataforma</mu-title>
                    <hr>
                    <mu-form ref="form" :model="form">
                        <div v-show="!a2f.status">
                            <mu-form-item label="Digite seu login" prop="username">
                                <mu-text-field v-model.trim="form.username" @keyup.enter="login()"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item label="Digite sua senha" prop="password">
                                <mu-text-field v-model.trim="form.password" type="password" @keyup.enter="login()"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item>
                                <mu-button round color="primary" @click="login()" :disabled="!form.username || !form.password">Entrar</mu-button>
                                <a href="javascript:;" @click="setScreen('forgotpassword')">
                                    <mu-flex>
                                        <span>Esqueceu sua senha</span> <font-awesome-icon icon="question-circle" />
                                    </mu-flex>
                                </a>
                            </mu-form-item>
                        </div>
                        <div v-show="a2f.status">
                            <p>Confira em seu celular ou e-mail o código de validação.</p>
                            <mu-form-item label="Código" prop="code">
                                <mu-text-field v-model.trim="form.code" @keyup.enter="login()"></mu-text-field>
                            </mu-form-item>
                            <mu-form-item>
                                <mu-button round color="primary" @click="login()" :disabled="!form.username || !form.password || !form.code">Validar código</mu-button>
                                <a href="javascript:;" @click="setScreen('login')">
                                    <mu-flex>
                                        <span>Voltar ao login</span> <font-awesome-icon icon="question-circle" />
                                    </mu-flex>
                                </a>
                            </mu-form-item>
                        </div>
                    </mu-form>
                </div>

                <div class="forgotpassword" v-if="screen == 'forgotpassword' && !loading.status">
                    <mu-title type="h2" color="primary" textStrong="700">Esqueci minha senha</mu-title>
                    <hr>
                    <mu-form ref="forgotpassword" :model="form">
                        <p>Você receberá em seu e-mail um link para gerar uma nova senha.</p>
                        <mu-form-item label="Digite seu login" prop="username">
                            <mu-text-field v-model="form.username" prop="username"></mu-text-field>
                        </mu-form-item>
                        <mu-form-item>
                            <mu-button round color="primary" @click="forgotPassword()" :disabled="!form.username">Enviar</mu-button>
                            <a href="javascript:;" @click="setScreen('login')">
                                <mu-flex>
                                    <font-awesome-icon icon="arrow-left" /> <span>Voltar</span>
                                </mu-flex>
                            </a>
                        </mu-form-item>
                    </mu-form>
                </div>

                <div class="loading" v-if="loading.status">
                    <mu-circular-progress color="primary" :stroke-width="1" :size="36"></mu-circular-progress>
                    <p>{{ loading.message }}.</p>
                </div>

                <div class="version left">
                    {{ version }}
                </div>

            </mu-col>
            <mu-col span="12" sm="12" md="5" lg="7" xl="7" class="login-bg">
                <mu-flex justify-content="center" align-items="center" class="svg">
                    <img src="/svg/login/icons.svg" alt="">
                </mu-flex>
            </mu-col>
        </mu-row>

        <!-- Snackbar -->
        <mu-snackbar position="bottom-start" :color="snackbar.type" :open.sync="snackbar.open">
            {{ snackbar.message }}
            <mu-button flat slot="action" color="#fff" @click="snackbar.open = false">Fechar</mu-button>
        </mu-snackbar>

    </div>
</template>

<script>
    import forgotPassword from '@/services/auth/forgot-password'
    // import * as Sentry from '@sentry/browser'
    import { version } from '@/../package.json'

    // ------------------------------------------------------------------------------------------

    // Configuração do sentry para logs do front
    // if (process.env.VUE_APP_SENTRY_DSN) {
    //     Sentry.init({
    //         dsn: process.env.VUE_APP_SENTRY_DSN,
    //         environment: process.env.NODE_ENV || 'development'
    //     })
    // }

    // ------------------------------------------------------------------------------------------

    export default {
        name: 'login',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                screen: 'login',
                version: `v.${version}`,
                loading: {
                    status: false,
                    message: ''
                },
                a2f: {
                    status: false
                },
                form: {
                    username: '',
                    password: '',
                    code: ''
                },
                snackbar: {
                    type: '',
                    message: '',
                    open: false,
                    timeout: 4000
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        /**
         * Praticamente todos os dados vem do state
         */
        computed: {
            onLine () {
                return this.$store.state.onLine
            }
        },

        // ╔╦╗╔═╗╦ ╦╔╗╔╔╦╗╔═╗╔╦╗
        // ║║║║ ║║ ║║║║ ║ ║╣  ║║
        // ╩ ╩╚═╝╚═╝╝╚╝ ╩ ╚═╝═╩╝

        mounted () {
            if (this.$store.state.authenticated) {
                this.$router.push({ name: 'app.dashboard' }).catch(err => { if (err) console.log(err.name || '') })
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Faz o login e redireciona para a dashboard caso der sucesso
             */
            login () {
                try {
                    this.loading.status = true
                    this.loading.message = 'Aguarde enquanto validamos seus dados.'
                    this.$store.dispatch('login', this.form).then((response) => {
                        this.loading.status = false
                        if (response && response.status) {
                            this.$router.push({ name: 'app.dashboard' }).catch(err => { if (err) console.log(err.name || '') })
                            return
                        }
                        if (response && response.status === false && response.code === 402) {
                            this.snackbarMessage('info', response.message)
                            this.a2f.status = true
                            return
                        }
                        this.snackbarMessage('error', response.message)
                    }).catch((response) => {
                        this.loading.status = false
                        this.loading.message = ''
                        let message = 'Não foi possível fazer o login.'
                        this.snackbarMessage('error', message)
                        // Sentry.captureException(new Error(`${message}... -----> Usuário: ${this.form.username}`))
                    })
                } catch (e) {
                    let message = 'Não foi possível fazer o login...'
                    this.snackbarMessage('error', e.message || message)
                    // Sentry.captureException(new Error(`${message} -----> Usuário: ${this.form.username}`))
                }
            },

            /**
             * Esqueci minha senha
             */
            async forgotPassword () {
                try {
                    this.loading.status = true
                    this.loading.message = 'Processando solicitação para gerar sua nova senha.'

                    let result = await forgotPassword({ UserName: this.form.username })
                    if (result.status) {
                        this.snackbarMessage('success', result.message)
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.snackbarMessage('error', e.message || 'Não foi possível solicitar a nova senha.')
                } finally {
                    this.loading.status = false
                    this.loading.message = ''
                }
            },

            /**
             * Alterna entre as subtelas 'login' e 'forgotpassword'
             */
            setScreen (screen) {
                if (screen === 'login') {
                    this.form.username = ''
                    this.form.password = ''
                    this.form.code = ''
                    this.a2f.status = false
                }
                this.screen = screen
            },

            /**
             * Controle do snackbar para o alerta das mensagens
             */
            snackbarMessage (type, message) {
                this.snackbar.open = true
                this.snackbar.type = type
                this.snackbar.message = message
                setTimeout(() => {
                    this.snackbar.open = false
                }, this.snackbar.timeout)
            }
        }
    }
</script>

<style lang="stylus">

    @import './../../assets/stylus/bootstrap.styl'

    // Mobile First

    body, html
        height 100%

    .auth

        height 100%

        .mu-alert
            max-width 600px
            margin auto

        .row
            height 100%

        .login, .forgotpassword
            max-width 350px
            margin auto
            margin-bottom 30px
            padding 15px

            hr
                border 0
                border-bottom 2px $primary solid
                width 20px
                margin 5px 0 20px 0

            a
                color #999
                font-size 12px
                margin-left 30px
                span
                    text-decoration underline
                svg
                    font-size 16px
                    margin 0 4px

                &:hover
                    color $primary

            .mu-form-item-label
                color #999
                font-size 12px

            .mu-button
                margin 0

        .loading
            text-align center
            color #888
            font-size 12px

        .version
            position fixed
            bottom 5px
            color #666
            left 5px
            font-size 11px

        .login-bg
            display none

    /* Acima de 700 pixels */
    @media (min-width: 700px)

        .auth

            .login-bg
                background url('/img/login-background.jpg') no-repeat center center
                background-size cover
                height 100%
                display block

                .svg
                    height 100%

                img
                    max-width 80%
                    max-height 80%

</style>
